module.exports = __webpack_public_path__ + "img/vehicle-maintenance-log-book_B09KN5V5KR.3de2063e.jpg";